import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import AuthContext from "../../../context/auth/AuthContext";
import { getUsers } from "../../../services/users";
import { pushNotificationKeys } from "../queryKeys";

const usePushUsers = (search = "", page = 0, pageSize = 20, enabled = true) => {
  const { tenant } = useContext(AuthContext);
  const tenantCode = tenant?.code;

  return useQuery({
    queryKey: pushNotificationKeys.users(tenantCode, search, page, pageSize),
    queryFn: () => getUsers(page, pageSize, search),
    enabled: Boolean(tenantCode && enabled),
    staleTime: 30_000,
  });
};

export default usePushUsers;
